import React from 'react';

import { FullscreenLoader } from 'src/components/common';
import { useCurrentUserVerifier } from 'src/hooks/verifier';

import {
  CommercialVerifierCompanyInformationForm,
  GovernmentVerifierCompanyInformationForm,
} from '../verifier';

export const CompanyInformationFormWrapperVerifierAdmin: React.FC = () => {
  const { verifierId, isCommercialVerifier, loading } = useCurrentUserVerifier();

  if (loading) {
    return (
      <FullscreenLoader
        sx={{
          height: '500px',
        }}
      />
    );
  }

  return isCommercialVerifier ? (
    <CommercialVerifierCompanyInformationForm verifierId={verifierId} />
  ) : (
    <GovernmentVerifierCompanyInformationForm verifierId={verifierId} />
  );
};
